module.exports = __webpack_public_path__ + "static/img/create-seasonal-promotion.f49c961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marketing/create-seasonal-promotion.png
// module id = 3PQH
// module chunks = 2